<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ store.product()?.name }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="'/vendors/' + store.product()?.vendorId" [text]="'COMMON.BACK' | translate" />
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        id="actions-trigger"
        color="medium"
        mode="ios"
        fill="solid"
        style="--border-radius: 10px"
        class="size-[36px] grow-0"
      >
        <ion-icon name="ellipsis-vertical" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="bg-surface scroll-visible">
  <div class="flex items-center justify-center md:mt-5">
    <div class="flex w-full max-w-full flex-col md:max-w-[550px]">
      <div class="w-max-mid w-full">
        @if (store.dynamicInfo(); as info) {
          @if (info.images.length > 0) {
            <mtjr-product-swiper
              [blurHash]="info.blurHash"
              [images]="info.images"
              [isVoucherVendor]="store.isVoucherVendor()"
            />
          } @else {
            <mtjr-product-swiper
              [blurHash]="info.blurHash"
              [images]="['https://nbg1.your-objectstorage.com/mtjr-prod/product-placeholder.webp']"
              [isVoucherVendor]="store.isVoucherVendor()"
            />
          }
        }
      </div>
      <div class="flex-grow">
        @if (store.product(); as product) {
          <div class="ms-4 mt-3 flex flex-col">
            <div class="flex">
              <ion-text class="flex-1 text-xl font-bold">{{ product.name }}</ion-text>
              <ion-text color="warning" class="me-3 text-lg font-bold">
                {{ store.selectedVariation()?.price ?? store.dynamicInfo().price | vxCurrency }}
              </ion-text>
            </div>
            <div class="bg-medium/10 mt-2 h-[1px] w-full"></div>
            <div class="flex items-center pe-4 pt-3 select-none">
              <ion-icon name="star-circle" class="me-1.5 text-xl" color="success" />
              <ion-text color="medium" class="flex-1">
                <span class="me-1">{{ product.ratingAvg | number: "1.1-1" }}</span>
                <span>( {{ product.ratingCount }} {{ "PRODUCTS.REVIEWS" | translate }} )</span>
              </ion-text>
              <ion-text
                class="text-md capitalize px-3 py-2 rounded-full"
                [ngClass]="{
                  'text-success bg-success/5': product.publishStatus === 'published',
                  'text-warning bg-warning/5': product.publishStatus === 'waitingForReview',
                  'text-danger bg-danger/5':
                    product.publishStatus === 'rejected' || product.publishStatus === 'unPublished',
                  'text-medium bg-medium/5': product.publishStatus === 'draft',
                }"
              >
                {{ "ENUMS.PublishStatus." + product.publishStatus | translate }}
              </ion-text>
            </div>

            @if (product.description) {
              <ion-text class="mt-4 text-xl">{{ "PRODUCTS.DESCRIPTION" | translate }}</ion-text>
              <ion-text class="me-3 mt-1 select-none" color="medium">{{ product.description }}</ion-text>
            }
          </div>
          @if (store.attributes().length > 0) {
            <mtjr-product-attributes-section
              [attributes]="store.attributes()"
              [selectedAttributes]="store.selectedAttributes()"
              [availableAttributes]="store.availableAttributes()"
              [productBgColor]="product.bgColor"
              [isVoucherVendor]="store.isVoucherVendor()"
              (attributeToggle)="onAttributeToggle($event)"
            />
          }
          <div class="my-3">
            <mtjr-product-reviews-section [productId]="product.id" />
          </div>
          <div
            class="mx-5 my-4 rounded-lg px-4 py-2 flex items-center justify-between"
            [ngClass]="{
              'text-success bg-success/10': store.dynamicInfo().available,
              'text-danger bg-danger/10': !store.dynamicInfo().available,
            }"
          >
            <ion-text>{{ "PRODUCTS.AVAILABLE_STOCK" | translate }}</ion-text>
            <ion-text class="text-lg font-bold">
              {{ store.dynamicInfo().stock }}
            </ion-text>
          </div>
        }
      </div>
    </div>
  </div>
  <mtjr-error-bar [failure]="publishStore.requestToPublishProductFailure()" />
</ion-content>
<ion-footer>
  <div class="mx-4 py-2 flex justify-center gap-2">
    @if (store.product(); as product) {
      @if (product.publishStatus === "published" || product.publishStatus === "waitingForReview") {
        <mtjr-submit-button
          fill="outline"
          color="warning"
          [state]="publishStore.unPublishProductState()"
          (click)="publishStore.unPublishProduct({ productId: product.id })"
          expand="block"
          shape="round"
          class="max-w-[200px] w-full"
          label="{{ 'PRODUCTS.UNPUBLISH_PRODUCT' | translate }}"
        />
      } @else if (product.publishStatus === "draft" || product.publishStatus === "unPublished") {
        <mtjr-submit-button
          fill="outline"
          [state]="publishStore.requestToPublishProductState()"
          (click)="sendForReview(product.id)"
          color="success"
          expand="block"
          shape="round"
          class="max-w-[200px] w-full"
          label="{{ 'PRODUCTS.PUBLISH_PRODUCT' | translate }}"
        />
      }
    }
  </div>
</ion-footer>
<ion-modal
  [isOpen]="shareModalOpen()"
  (willDismiss)="shareModalOpen.set(false)"
  cssClass="rounded-dialog"
  [breakpoints]="[0.0, 0.35]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>{{ "COMMON.SHARE" | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="shareModalOpen.set(false)">
            <ion-text>
              {{ "COMMON.CANCEL" | translate }}
            </ion-text>
            <ion-icon slot="end" name="close" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="bg-surface ion-padding">
      <div class="flex flex-col items-center">
        <div class="grid grid-cols-3 gap-5 w-full">
          <!-- copy -->
          <div class="flex flex-col items-center gap-1" (click)="copyToClipboard(currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-dark mb-1 cursor-pointer">
              <ion-icon name="copy-outline" class="text-2xl text-gray-700"></ion-icon>
            </div>
            <ion-text class="text-xs">{{ "COMMON.COPY_LINK" | translate }}</ion-text>
          </div>

          <!-- Facebook -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('facebook', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 mb-1 cursor-pointer">
              <ion-icon name="logo-facebook" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Facebook</ion-text>
          </div>

          <!-- Twitter/X -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('twitter', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="logo-twitter" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">X</ion-text>
          </div>

          <!-- WhatsApp -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('whatsapp', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 mb-1 cursor-pointer">
              <ion-icon name="logo-whatsapp" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">WhatsApp</ion-text>
          </div>

          <!-- Telegram -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('telegram', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-400 mb-1 cursor-pointer">
              <ion-icon name="paper-plane" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Telegram</ion-text>
          </div>

          <!-- LinkedIn
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('linkedin', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-800 mb-1 cursor-pointer">
              <ion-icon name="logo-linkedin" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">LinkedIn</ion-text>
          </div> -->

          <!-- Native -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('native', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="share-social-outline" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Native</ion-text>
          </div>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
<ion-popover trigger="actions-trigger" [dismissOnSelect]="true" size="cover">
  <ng-template>
    <ion-content>
      @if (store.product(); as product) {
        <ion-list class="!p-0">
          <ion-item [button]="true" [detail]="false" routerLink="edit">
            <ion-icon name="create-outline" slot="start"></ion-icon>
            <ion-label>{{ "COMMON.EDIT" | translate }}</ion-label>
          </ion-item>
          <ion-item [button]="true" [detail]="false" (click)="openShareOptions(productId)">
            <ion-icon name="share-social-outline" slot="start"></ion-icon>
            <ion-label>{{ "COMMON.SHARE" | translate }}</ion-label>
          </ion-item>
          <ion-item [button]="true" [detail]="false" (click)="addToOrder()">
            <ion-icon name="add" slot="start"></ion-icon>
            <ion-label>{{ "ORDERS.EXTERNAL_ORDER" | translate }}</ion-label>
          </ion-item>
        </ion-list>
      }
    </ion-content>
  </ng-template>
</ion-popover>
